module.exports = __webpack_public_path__ + "img/chouqian-bg-image.5ff1c904.png";